export default "/kiban/_next/static/images/show-4031031abfe3153fb4f9516b9cc27b4d.svg";